import { isNative } from "@/lib/native";
import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCurrency } from "@/context/CurrencyContext";

// Limited-time founding launch offer banner (free users only).
export default function IntroOffer({ onSubscribe }) {
  const { user } = useAuth();
  const { prices } = useCurrency();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("astra_intro_dismissed") === "1");

  if (user?.is_premium || user?.is_demo || isNative || dismissed) return null;

  return (
    <div
      data-testid="intro-offer-banner"
      className="relative overflow-hidden rounded-2xl p-4 mb-5 border border-[#D4AF37]/40"
      style={{ background: "linear-gradient(120deg, rgba(212,175,55,0.18), rgba(26,18,48,0.6))" }}
    >
      <button
        data-testid="btn-intro-dismiss"
        onClick={() => {
          localStorage.setItem("astra_intro_dismissed", "1");
          setDismissed(true);
        }}
        className="absolute top-2.5 right-2.5 text-[#A7B0C0] hover:text-starlight"
      >
        <X size={16} />
      </button>
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={15} className="gold-text" />
        <p className="text-[11px] uppercase tracking-[0.3em] gold-text">Founding Offer · Limited Time</p>
      </div>
      <p className="text-lg text-starlight leading-snug mb-1">
        Astra Premium from{" "}
        <span className="gold-glow-text font-medium">{prices.symbol}{prices.annualPerMonth}/mo</span>
      </p>
      <p className="text-sm text-[#A7B0C0] mb-3">
        Billed annually at {prices.symbol}{prices.annualTotal} — save 33% while our stars are still rising.
      </p>
      <button
        data-testid="btn-intro-claim"
        onClick={() => onSubscribe("the founding offer")}
        className="bg-[#D4AF37] hover:bg-[#e6c04e] text-[#04060B] font-medium text-base px-5 py-2.5 rounded-full transition-colors"
      >
        Claim founding offer
      </button>
    </div>
  );
}
